export const RED = '#E5261F';
export const GREEN = '#55BD9D';
